import React, { useEffect, useState } from 'react'
import { Button, Col, Row, Table } from 'react-bootstrap'
import { BsPlusLg } from 'react-icons/bs'
import { useSelector } from 'react-redux'
import TableCertificate from './table-certificate'
import ModalCertificate from './modal-certificate'
import {
  getCetificateHaveAPI,
  getTrainingListAPI
} from '../../../services/certificate'
import { FaCircleCheck } from 'react-icons/fa6'

function ProfileCertificate() {
  const profile = useSelector((state) => state.loginReducer.profile)
  const orgId = profile.org_id
  const code = profile.code
  const [onOpen, setOnOpen] = useState(false)
  const [isSave, setIsSave] = useState(false)
  const [dataTable, setDataTable] = useState([])
  const [dataMapping, setDataMapping] = useState([])
  const [have, setHave] = useState([])

  useEffect(() => {
    const param = {
      orgId,
      code
    }
    if (orgId && code) {
      getCertificate(param)
      getCetificateHave(param)
    }
  }, [orgId, isSave])

  const getCertificate = async (param) => {
    const res = await getTrainingListAPI(param)
    if (!res) return
    if (res.status) {
      setDataTable(res.result)

      const newData = res.result.map((d, i) => {
        return {
          courseFee: d.course_fee,
          courseId: d.course_id,
          isFile: d.isFile,
          id: d.id
        }
      })
      setDataMapping(newData)
    }
  }

  const getCetificateHave = async (param) => {
    // const param = {orgId, code}
    const res = await getCetificateHaveAPI(param)
    if (!res) return
    if (res.status) {
      setHave(res.result)
    }
  }

  const handleOpen = () => {
    setOnOpen(true)
  }

  const handleClose = () => {
    setOnOpen(false)
  }


  return (
    <Row>
      <Col xl={12} className="d-flex justify-content-between mb-3">
        <div className="d-flex justify-content-start">
          {' '}
          <span className="my-auto text-primary me-2">Certificate</span>
          {have?.status_id === 0 ? (
            <div className="text-secondary mt-1">
              <span className="me-1">
                {' '}
                <FaCircleCheck />{' '}
              </span>
              <span className="small">{have?.status_name}</span>
            </div>
          ) : (
            <></>
          )}
        </div>

        <div className="d-flex justify-content-end">
          <Button
            size="sm"
            onClick={handleOpen}
            style={{
              width: '150px'
            }}
          >
            <BsPlusLg /> Certificate 
          </Button>
        </div>
      </Col>
      <Col className="">
        <>
          <div className="">
            <Row style={{ rowGap: '15px' }}>
              <Table>
                <thead
                  className="bg-hrms text-white "
                  style={{ position: 'sticky', top: '0px' }}
                >
                  <tr className="font-title-table">
                    <td
                      className="text-center"
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      #
                    </td>
                    <td style={{ whiteSpace: 'nowrap' }}>Course/ Exam Name</td>

                    <td style={{ whiteSpace: 'nowrap' }}>Type of Course</td>
                    <td style={{ whiteSpace: 'nowrap' }}>Start Date</td>
                    <td style={{ whiteSpace: 'nowrap' }}>End Date</td>
                    <td style={{ whiteSpace: 'nowrap' }}>Course Fee</td>

                    <td style={{ whiteSpace: 'nowrap' }}>Brand/ Partner</td>
                    <td style={{ whiteSpace: 'nowrap' }}>Status</td>
                    <td style={{ whiteSpace: 'nowrap' }}>Active</td>
                    <td style={{ whiteSpace: 'nowrap' }}>Insert Date</td>

                    <td
                      className="text-center"
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      <span className="fw-normal ">File </span>
                      <span className="fw-light small ">(PDF Max 8 MB)</span>
                    </td>
                    {/* <td style={{ whiteSpace: 'nowrap' }}>Upload (PDF)</td> */}
                    <td
                      className="text-center"
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      Edit
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {dataTable.length > 0 ? (
                    dataTable.map((d, i) => (
                      <>
                        <TableCertificate
                          setIsSave={setIsSave}
                          isSave={isSave}
                          data={d}
                          keys={i}
                          dataMapping={dataMapping}
                          isFile={d.isFile}
                          fnData={getCertificate}
                          orgId={orgId}
                          code={code}
                        />
                      </>
                    ))
                  ) : (
                    <tr className="fw-light ">
                      <td colSpan={12} className="text-center">
                        - No data -
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Row>
          </div>
        </>
        {onOpen && (
          <ModalCertificate
            have={have}
            onOpen={onOpen}
            handleClose={handleClose}
            fnData={getCertificate}
            isSave={isSave}
            setIsSave={setIsSave}
            orgId={orgId}
            code={code}
            getCetificateHave={getCetificateHave}
          />
        )}
      </Col>
    </Row>
  )
}

export default ProfileCertificate
